import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/favorites/components/FavoritesPageContent.tsx");
